import client from 'client';

export const addMarker = async (marker: Marker) => {
    return client().post<Marker[]>('/api/v2/userProfile/markers', marker);
};

export const deleteMarker = async (marker: Marker) => {
    return client().delete<Marker[]>('/api/v2/userProfile/markers', { data: marker });
};

export const fetchMarkers = async () => {
    const response = await client().get<Marker[]>('/api/v2/userProfile/markers');
    return response.data;
};

export type Marker = {
    eventId: number;
    userProfileId: number;
    markerType: 'addToCal';
    entity: 'sessions';
    entityId: number;
    modified?: string;
    id?: number;
};
